import { useAuth } from "../components/auth/context";

export const useMe = () => {
  const { isAuthorized } = useAuth();
  return { isAuthorized };
};


export const useBranch = () => {
  const { branch, setBranch } = useAuth();

  return { branch, setBranch };
};